export class NatConProperties {
  title?: string;
  photoLink?: string;
  videos: NatConVideoProperties[];
  resources: NatConResource[];
  audios: NatConAudioProperties[];
  audioFootnote?: string;
  archives: NatConResource[];

  get sidebarContentAvailable(): boolean {
    return !!(this.videos?.length || this.resources?.length || this.audios?.length || this.archives?.length);
  }

  public constructor(year?: string) {
    switch (year) {
      case '2022':
        this.title = '114th US Bahá’í National Convention: April 21 – 24, 2022';
        this.photoLink = 'https://www.flickr.com/photos/bahaius/collections/72157720600186911/';
        this.videos = [
          {
            title: 'Secretary’s Report',
            videoLink: 'https://player.vimeo.com/video/702556483?h=a038cdc647',
            audioLink:
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1257403156&color=%2336717a&inverse=false&auto_play=false&show_user=false',
            downloadLink: 'https://vimeo.com/usbahai/download/702556483/03a598006c',
          },
          {
            title: 'Treasurer’s Report',
            videoLink: 'https://player.vimeo.com/video/702257856?h=0c0dd100ae',
            downloadLink: 'https://vimeo.com/usbahai/download/702257856/46ae05d679',
          },
          {
            title: 'Ḥuqúqu’lláh Presentation',
            videoLink: 'https://player.vimeo.com/video/704258078?h=af966267b0',
          },
        ];
        this.resources = [
          {
            title: 'Nine Year Plan documents',
            link: '/nine-year-plan',
          },
          {
            title: 'Ridvan 2022 Message from the Supreme Body',
            link: '/guidance/uhj/ridvan-2022-message-from-the-supreme-body-2022',
          },
          {
            title: 'Ridván 2022 Annual Report',
            link: 'https://bahai-web.s3.amazonaws.com/NatCon/2022/2022-Annual-Report.pdf',
          },
          {
            title: 'Letter from the 114th US Bahá’í National Convention',
            link:
              '/guidance/national_spiritual_assembly/letter-from-the-114th-us-baha-i-national-convention-2022/letter-from-the-114th-us-baha-i-national-convention-2022',
          },
          {
            title: 'Election of the National Spiritual Assembly',
            link: '/guidance/national_spiritual_assembly/election-of-the-national-spiritual-assembly-2022',
          },
        ];
        this.audios = [
          {
            title: 'Thursday Consultation',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1257605635&color=%2336717a&inverse=false&auto_play=false&show_user=false',
            ],
          },
          {
            title: 'Friday Consultation',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258821058&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258012570&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258012558&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258821229&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258821253&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258012531&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258012525&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258012513&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258012511&color=%2336717a&inverse=false&auto_play=false&show_user=false',
            ],
          },
          {
            title: 'Saturday Consultation',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258025002&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258024984&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258024966&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258823893&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258823812&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258823752&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258024897&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258024888&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258823779&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258024867&color=%2336717a&inverse=false&auto_play=false&show_user=false',
            ],
          },
          {
            title: 'Sunday Consultation',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258825945&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258026658&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258026649&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258825978&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1258825963&color=%2336717a&inverse=false&auto_play=false&show_user=false',
            ],
          },
        ];
        this.archives = [];
        break;
      case '2023':
        this.title = '115th US Bahá’í National Convention: May 18 – 21, 2023';
        this.photoLink = 'https://www.flickr.com/photos/bahaius/collections/72157721746069947/';
        this.videos = [
          {
            title: 'Secretary’s Report',
            videoLink: 'https://player.vimeo.com/video/828498465?h=0ffb5f9edc',
            downloadLink:
              'https://player.vimeo.com/progressive_redirect/playback/828498465/rendition/1080p/file.mp4?loc=external&log_user=0&signature=7fb2015f27dd105cab68dc3f91a4088ead2264e335c93415cf4e1357bdbc1fdc',
          },
          {
            title: 'Treasurer’s Report',
            videoLink: 'https://player.vimeo.com/video/828504023?h=3e3e408818',
            downloadLink:
              'https://player.vimeo.com/progressive_redirect/playback/828504023/rendition/1080p/file.mp4?loc=external&signature=94143f10a7b39ed0807a79df5917fdf00da3aa4f93537fc9a41d3458eb9e7088',
          },
        ];
        this.resources = [
          {
            title: 'Nine Year Plan documents',
            link: '/nine-year-plan',
          },
          {
            title: 'Ridvan 2023 Message from the Supreme Body',
            link: '/guidance/uhj/ridvan-2023-message-from-the-supreme-body-2023/ridvan-2023-message-from-the-supreme-body-2023',
          },
          {
            title: 'Ridván 2023 Annual Report',
            link:
              '/guidance/national_spiritual_assembly/national-spiritual-assembly-shares-ridvan-2023-annual-report-2023/national-spiritual-assembly-shares-ridvan-2023-annual-report-2023',
          },
          {
            title: 'Universal House of Justice Responds to Message from 2023 National Convention',
            link: '/guidance/uhj/universal-house-of-justice-responds-to-message-from-2023-national-convention-2023',
          },
        ];
        this.audios = [
          {
            title: 'Remarks from the Continental Counselors',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527047419&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527047104&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527047449&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527047368&color=%2336717a&inverse=false&auto_play=false&show_user=false',
            ],
          },
          {
            title: 'Administration',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527039316&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527039292&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527039244&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527039217&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527039184&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527039172&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527039136&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527039115&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527039085&color=%2336717a&inverse=false&auto_play=false&show_user=false',
            ],
          },
          {
            title: 'Love',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527049726&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527049684&color=%2336717a&inverse=false&auto_play=false&show_user=false',
            ],
          },
          {
            title: 'Race',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527050737&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527050716&color=%2336717a&inverse=false&auto_play=false&show_user=false',
            ],
          },
          {
            title: 'Social Action',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527052213&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527052138&color=%2336717a&inverse=false&auto_play=false&show_user=false',
            ],
          },
          {
            title: 'Youth',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527054226&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527054202&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527054148&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527054064&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1527053986&color=%2336717a&inverse=false&auto_play=false&show_user=false',
            ],
          },
        ];
        this.archives = [
          {
            title: 'National Convention 2022',
            link: '/news/natcon-2022',
          },
        ];
        break;
      case '2024':
        this.photoLink = 'https://www.flickr.com/photos/bahaius/collections/72157722768523226/';
        this.resources = [
          {
            title: 'Swahili National Convention Report',
            link: 'https://drive.google.com/file/d/1zpzdbtHvsnRXPm1Qgukras2AVubabY1C/view?usp=sharing',
          },
          {
            title: 'Nine Year Plan documents',
            link: '/nine-year-plan',
          },
          {
            title: 'Ridvan 2024 Message from the Supreme Body',
            link: '/guidance/uhj/ridvan-2024-message-from-the-supreme-body-2024/ridvan-2024-message-from-the-supreme-body-2024',
          },
          {
            title: 'Ridván 2024 Annual Report',
            link: 'https://bahai-web.s3.amazonaws.com/messages/AnnualReports/2024-US-NSA-Annual-Report.pdf',
          },
        ];
        this.videos = [
          {
            title: 'Secretary’s Report',
            videoLink: 'https://player.vimeo.com/video/940040610?h=0ffb5f9edc',
            downloadLink:
              'https://player.vimeo.com/progressive_redirect/download/940040610/rendition/540p/116th_us_baha%E2%80%99i_national_convention_secretary_report_2024%20%28540p%29.mp4?loc=external&signature=36ead21bbefcd375524bd07964d81902ca6522673f26e1f60348ad9ca7a00b35',
            audioLink:
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1809265746%3Fsecret_token%3Ds-47NPAK9bqOC&color=%2336717a&inverse=false&auto_play=false&show_user=false',
          },
          {
            title: 'Treasurer’s Report',
            videoLink: 'https://player.vimeo.com/video/940281101?h=3e3e408818',
            downloadLink:
              'https://player.vimeo.com/progressive_redirect/download/940281101/rendition/540p/116th_us_baha%E2%80%99i_national_convention_treasurer%27s_report_2024%20%28540p%29.mp4?loc=external&signature=0db3111e21c74b08b53feb95ec8243c3d29fbaf0a5cd322faf13a3568f59812d',
            audioLink:
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1809757728%3Fsecret_token%3Ds-LqfRwnTia9H&color=%2336717a&inverse=false&auto_play=false&show_user=false',
          },
          {
            title: 'Presentation on Ḥuqúqu’lláh',
            videoLink: 'https://player.vimeo.com/video/944248523?h=3e3e408818',
          },
        ];
        this.audios = [
          {
            title: 'Remarks from the Continental Counselors',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1818459723%3Fsecret_token%3Ds-ovWgNmp4g9y&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1818460227%3Fsecret_token%3Ds-4IGAWYp4dEj&color=%2336717a&inverse=false&auto_play=false&show_user=false',
            ],
          },
          {
            title: 'Comments from the National Spiritual Assembly',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1823535744%3Fsecret_token%3Ds-ApP6E5zdWEy&color=%2336717a&inverse=false&auto_play=false&show_user=false',
            ],
          },
          {
            title: 'The Institute Process',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1818460587%3Fsecret_token%3Ds-WEfWMVBrgG1&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1818462126%3Fsecret_token%3Ds-a7GPY49e2o6&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1818461049%3Fsecret_token%3Ds-NE1PByDX8Cs&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1818461373%3Fsecret_token%3Ds-hBDztgi6HZq&color=%2336717a&inverse=false&auto_play=false&show_user=false',
            ],
          },
          {
            title: 'Educational Endeavors',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1818462795%3Fsecret_token%3Ds-ak2b3Wcrs65&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1818463038%3Fsecret_token%3Ds-s1o8MceYSgF&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1818463254%3Fsecret_token%3Ds-UYlYLz4GJIi&color=%2336717a&inverse=false&auto_play=false&show_user=false',
            ],
          },
          {
            title: 'Youth',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1818463524%3Fsecret_token%3Ds-nMUxiq7hRvh&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1818463746%3Fsecret_token%3Ds-0HnWPY4zK78&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1818464154%3Fsecret_token%3Ds-sRy8ZvyuUrn&color=%2336717a&inverse=false&auto_play=false&show_user=false',
            ],
          },
          {
            title: 'Local Spiritual Assembly',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1818464463%3Fsecret_token%3Ds-5Pttb2oRvXJ&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1818464685%3Fsecret_token%3Ds-5LYHsyXImK3&color=%2336717a&inverse=false&auto_play=false&show_user=false',
            ],
          },
          {
            title: 'Special Sessions',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1818465066%3Fsecret_token%3Ds-esD6qVBKEsY&color=%2336717a&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1818465402%3Fsecret_token%3Ds-yTOYffdxz1K&color=%2336717a&inverse=false&auto_play=false&show_user=false',
            ],
          },
        ];
        this.archives = [
          {
            title: 'National Convention 2023',
            link: '/news/natcon-2023',
          },
          {
            title: 'National Convention 2022',
            link: '/news/natcon-2022',
          },
        ];
        break;
      case '2025':
        this.photoLink = 'https://www.flickr.com/photos/bahaius/collections/72157723720515344/';
        this.resources = [
          {
            title: 'Nine Year Plan documents',
            link: '/nine-year-plan',
          },
          {
            title: 'Ridván 2025 Message from the Supreme Body',
            link: '/guidance/uhj/ridvan-2025-message-from-the-supreme-body-2025/ridvan-2025-message-from-the-supreme-body-2025',
          },
          {
            title: 'Ridván 2025 Annual Report',
            link: 'https://bahai-web.s3.us-east-1.amazonaws.com/messages/AnnualReports/Ridvan+Annual+Report+2025.pdf',
          },
        ];
        this.videos = [
          {
            title: 'Secretary’s Report',
            videoLink: 'https://player.vimeo.com/video/1078804386?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
          },
          {
            title: 'Treasurer’s Report',
            videoLink: 'https://player.vimeo.com/video/1078827311?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
          },
          {
            title: 'Ḥuqúqu’lláh Presentation',
            videoLink: 'https://player.vimeo.com/video/1096642164?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
          },
        ];
        this.audios = [
          {
            title: 'Accompaniment',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652437%3Fsecret_token%3Ds-VGZL8u7L2Dw&color=%230066cc&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652479%3Fsecret_token%3Ds-cgbdG22wCs3&color=%230066cc&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652440%3Fsecret_token%3Ds-kn29YH45zHl&color=%230066cc&inverse=false&auto_play=false&show_user=false',
            ],
          },
          {
            title: 'Advanving Clusters',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652485%3Fsecret_token%3Ds-jwk8kBpBSZd&color=%230066cc&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652473%3Fsecret_token%3Ds-qTtpwv2Yuyq&color=%230066cc&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652434%3Fsecret_token%3Ds-mjf6lp4uSIh&color=%230066cc&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652455%3Fsecret_token%3Ds-sotiCREwVcb&color=%230066cc&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652431%3Fsecret_token%3Ds-uLiGdWgdrjk&color=%230066cc&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652482%3Fsecret_token%3Ds-NNaQX1IjnlN&color=%230066cc&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652434%3Fsecret_token%3Ds-mjf6lp4uSIh&color=%230066cc&inverse=false&auto_play=false&show_user=false',
            ],
          },
          {
            title: 'Natural Disaster Response',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652443%3Fsecret_token%3Ds-RKyWWDUUGuW&color=%230066cc&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652449%3Fsecret_token%3Ds-wWstof0SWru&color=%230066cc&inverse=false&auto_play=false&show_user=false',
            ],
          },
          {
            title: 'Race Unity - Overcoming Prejudices',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652464%3Fsecret_token%3Ds-c6dku8O7l59&color=%230066cc&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652452%3Fsecret_token%3Ds-PZ27xjHYIcr&color=%230066cc&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652476%3Fsecret_token%3Ds-uWZA27kuf4B&color=%230066cc&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652461%3Fsecret_token%3Ds-9MvJQFvQTbu&color=%230066cc&inverse=false&auto_play=false&show_user=false',
            ],
          },
          {
            title: 'Youth - JY Initiatives',
            links: [
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652467%3Fsecret_token%3Ds-drpV4z3mj4U&color=%230066cc&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652494%3Fsecret_token%3Ds-IihPjv50KsL&color=%230066cc&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652458%3Fsecret_token%3Ds-kt0f574WPyI&color=%230066cc&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652446%3Fsecret_token%3Ds-Umh9pyi6s8E&color=%230066cc&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652488%3Fsecret_token%3Ds-LPhcsNVKqG1&color=%230066cc&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652470%3Fsecret_token%3Ds-QTUvmm3OnAK&color=%230066cc&inverse=false&auto_play=false&show_user=false',
              'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652491%3Fsecret_token%3Ds-hwz71kXcMlg&color=%230066cc&inverse=false&auto_play=false&show_user=false',
            ],
          },
        ];
        this.audioFootnote = 'These audio excerpts are only playable on this page. They are not available to download.';
        this.archives = [
          {
            title: 'National Convention 2024',
            link: '/news/natcon-2024',
          },
          {
            title: 'National Convention 2023',
            link: '/news/natcon-2023',
          },
          {
            title: 'National Convention 2022',
            link: '/news/natcon-2022',
          },
        ];
        break;
      default:
        this.photoLink = '';
        this.resources = [];
        this.videos = [];
        this.audios = [];
        this.archives = [];
        break;
    }
  }
}

export class NatConVideoProperties {
  title: string;
  videoLink: string;
  audioLink?: string;
  downloadLink?: string;
}

export class NatConResource {
  title: string;
  link?: string;
}

export class NatConAudioProperties {
  title: string;
  links: string[];
}
